import axios from 'axios'
import qs from 'qs'
import { snakeProps } from 'change-prop-case'

// error.statusでレスポンスステータスを取れるようにする
function setErrorStatus(error) {
  if (error.response) {
    error.status = error.statusCode = error.response.status
  }
  return Promise.reject(error)
}

function createInstance(getToken, config) {
  let axiosInstance = axios.create(
    Object.assign(
      {
        paramsSerializer: params =>
          qs.stringify(snakeProps(params), { indices: false }),
      },
      config
    )
  )
  // set token interceptors
  axiosInstance.interceptors.response.use(res => res.data, setErrorStatus)
  axiosInstance.interceptors.request.use(
    config => {
      // NOTE: axios.defaultsを使用すると別ユーザに影響がでるため
      // interceptorでtokenをセットする
      let token = null
      if (typeof getToken === 'function') {
        token = getToken()
      }
      if (!token) return config
      if (token) config.headers.common['Authorization'] = 'JWT ' + token
      return config
    },
    err => Promise.reject(err)
  )
  return axiosInstance
}

function createAll(http) {
  return function all(paramsOrCb, cb) {
    let params = paramsOrCb
    if (typeof paramsOrCb === 'function') {
      cb = paramsOrCb
      params = {}
    } else {
      params = params || {}
    }

    let r = []
    let request = async url => {
      let { results, next } = await (url ? http.get(url) : this.list(params))
      r = r.concat(results)
      if (typeof cb === 'function') cb(r)
      if (next) return request(url)
      else return r
    }
    return request()
  }
}

function _createAPI(getToken) {
  const API_ENDPOINT =
    process.env.VUE_APP_API_ENDPOINT || 'http://localhost:30000/api/2/'
  let api = createInstance(getToken, {
    baseURL: API_ENDPOINT,
  })
  console.log('api endpoint', API_ENDPOINT)

  let http = {
    axios,
    http: api,
    auth: {
      obtainToken: data => api.post('auth/', data),
      refreshToken: data => api.post('auth/refresh/', data),
    },
    // account: {
    //   get: () => api.get('accounts/profile').then(data => data.data),
    // },
    shops: id => ({
      get: params => api.get(`shops/${id}/`, { params }),
      list: params => api.get('shops/', { params }),
      getGroupedMenus: () => api.get(`shops/${id}/menus/grouped/`),
      menus: menuId => ({
        get: params => api.get(`shops/${id}/menus/${menuId}/`, { params }),
        list: params => api.get(`shops/${id}/menus/`, { params }),
        all: createAll(http),
        reservableTimes: date => ({
          get: params =>
            api.get(`shops/${id}/menus/${menuId}/reservable_times/${date}/`, {
              params,
            }),
        }),
      }),
      menuOptions: optionId => ({
        get: params =>
          api.get(`shops/${id}/menu_options/${optionId}/`, { params }),
        list: params => api.get(`shops/${id}/menu_options/`, { params }),
        all: createAll(http),
      }),
      scalpCares: careId => ({
        get: params =>
          api.get(`shops/${id}/scalp_cares/${careId}/`, { params }),
        list: params => api.get(`shops/${id}/scalp_cares/`, { params }),
        all: createAll(http),
      }),
    }),
    reservations: id => ({
      get: params => api.get(`reservations/${id}/`, { params }),
      createInShop: data => api.post(`reservations/create_in_shop/`, data),
      validateInShop: data => api.post(`reservations/validate_in_shop/`, data),
    }),

    customers: id => ({
      get: () => api.get(`customers/${id}/`, { params: { simple: true } }),
      partialUpdate: data =>
        api.patch(`customers/${id}/`, data, { params: { simple: true } }),
    }),
  }

  return http
}

export let api = null

export default getToken => {
  api = _createAPI(getToken)
  return api
}
